module.exports = __webpack_public_path__ + "img/Rectangle-4.ad5987b6.png";